import { BsCaretDownFill } from "react-icons/bs";
import { Wrapper } from "../../layout";
import './index.css';
import InputValidationWarning from "../InputValidationWarning";

// to be refactored
export default function BaseSelectInput({ 
    label, 
    id, 
    name, 
    options,
    bold = true,
    required = false,
    handleChange,
    placeholder,
    invalid = false,
    selectedValue,
    warning,
    // use with caution
    overrides
}) {
    return (
        <Wrapper>
            {/* {onAddClick && <InputAddButton isLoading={isLoading} onClick={onAddClick}/>} */}
            {label && (
                <label 
                    htmlFor={id}
                    style={{
                        fontSize: ".8rem",
                        color: "#606061",
                        fontWeight: bold ? 600 : 500
                    }}
                >
                    {label}
                    {required && <span style={{ color: "#BF211E" }}> *</span>}
                </label>
            )}
            <div
                style={{
                    position: "relative",
                }}
                className={`select-input ${invalid ? "invalid" : ""}`}
            >
                <select 
                    name={name} 
                    id={id} 
                    onChange={handleChange}
                    value={selectedValue}
                    style={{
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        appearance: "none",
                        padding: ".375rem .75rem",
                        borderRadius: "5px",
                        backgroundColor: "#fff",
                        height: "58px",
                        margin: 0,
                        fontSize: ".8125rem",
                        fontWeight: 400,
                        fontFamily: "inherit",
                        color: "#212529",
                        lineHeight: 1.5,
                        width: "100%",
                        border: "4px solid rgba(0, 0, 0, 0.22)",
                        ...overrides
                    }}
                >
                    <option value={placeholder} disabled>{placeholder}</option>
                    {options.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
                <BsCaretDownFill
                    style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        pointerEvents: "none",
                        fill: "#606061",
                        transform: "translateY(-50%)"
                    }}
                />
            </div>
            <InputValidationWarning warning={warning}/>
        </Wrapper>
    )
}